/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * Copyright IBM Corp. 2017, 2020
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'jquery',
	'../../lib/@waca/baglass/js/baglass/app/plugins/MenuActionInterface'
], function($, MenuActionInterface) {
	'use strict';

	class AccountSettingsMenuController extends MenuActionInterface {

		onRender(context) {
			const { target } = context;
			if (target.plugin && target.plugin.getButtonElement){
				const button = target.plugin.getButtonElement();
				if (button) {
					button.find('svg').addClass('svgIcon').wrap('<div class="account-settings-background"/>');
				}
			}
		}

		isItemVisible() {
			return false;
		}
	}
	return AccountSettingsMenuController;
});
